import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

//Primereact components
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Badge } from 'primereact/badge';
import { Button } from 'primereact/button';

import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { VERIFICATION_LIST } from '../../../config/ApiConstant';
import { getAllDetailsDirect } from '../../../service/ProductService';
import { VerificationListColumns } from '../../../appconfig/DatatableSetting';
import { SkeletonbodyTemplate, Skeletonitems } from '../../../appconfig/Settings';
import { formatDateTime } from '../../../appconfig/AppHelper';

export const VerificationList = () => {
    document.title = 'Verification List | GSPC';

    // Parameters
    const { fileNo }: any = useParams();

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [verificationList, setVerificationList] = useState<any>([]);
    const [userData, setUserData] = useState<any>({});

    useEffect(() => {
        getVerificationList();
    }, []);

    // Get verification list
    const getVerificationList = async () => {
        setPageLoad(false);
        const response = await getAllDetailsDirect(VERIFICATION_LIST + '?SrNo=' + atob(fileNo));
        if (response) {
            setUserData(response?.user_data);
            const DataList: any = response;
            if (DataList.length === 0) {
                setVerificationList([]);
            } else {
                setVerificationList(response?.data);
            }
            setPageLoad(true);
        }
    };

    // Template for comment
    const commentTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="desc-wrap">{rowData?.comment}</div>
            </>
        );
    };

    // Template for verification order date
    const verificationOrderDateTemplate = (rowData: any, rowIndex: any) => {
        return <>{formatDateTime(rowData?.created_at)}</>;
    };

    // Template for verification date
    const verificationDateTemplate = (rowData: any, rowIndex: any) => {
        return <>{formatDateTime(rowData?.verification_date)}</>;
    };

    // Template for reply
    const replyTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="desc-wrap">{rowData?.reply}</div>
            </>
        );
    };

    // Template for action
    const actionTemplate = (rowData: any, rowIndex: any) => {
        return <>-</>;
    };

    // Template for file url
    const fileUrlTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <Button tooltip={!window.cn(rowData?.file_url) ? 'View Verification Files' : 'No Files'} className="p-button-primary" onClick={() => viewDocument(rowData?.file_url)} disabled={!window.cn(rowData?.file_url) ? false : true} />
            </>
        );
    };

    // Template for reply file url
    const replyFileTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <Button tooltip={!window.cn(rowData?.reply_file) ? 'Reply Files' : 'No Files'} className="p-button-primary" onClick={() => viewDocument(rowData?.reply_file)} disabled={!window.cn(rowData?.reply_file) ? false : true} />
            </>
        );
    };

    // View Document
    const viewDocument = (fileUrl: any) => {
        const fileName = `Verification-Data-${new Date().getTime()}`;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
    };

    return (
        <>
            <AppBreadcrumb currentMenu={'Applications'} pageName={'Verification List'} pageTitle={'Verification List'} goToPage={true} />

            <div className="card">
                <div className="grid">
                    <div className="field col-12 md:col-6  grid flex-column mb-0">
                        <div className="field col-12 grid mb-3">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>Full Name</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">{!window.cn(userData?.StudL) ? userData?.StudL + ' ' + userData?.StudF + ' ' + userData?.StudM : ''}</div>
                        </div>

                        <div className="field col-12 grid">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>App Status</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-7 mb-0">{!window.cn(userData?.appStatus) && userData?.appStatus === 'Approved' ? <Badge severity="success" value="Approved"></Badge> : userData?.appStatus}</div>
                        </div>
                    </div>

                    <div className="field col-12 md:col-6 grid flex-column align-items-end mb-0">
                        <div className="field col-12 grid mb-3 justify-content-end">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>File No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0">{!window.cn(userData?.SrNo) ? userData?.SrNo : ''}</div>
                        </div>

                        <div className="field col-12 grid justify-content-end mb-0">
                            <div className="field col-12 md:col-2 mb-0">
                                <b>Reg No</b>
                            </div>
                            <div className="field col-12 md:col-1 mb-0">:</div>
                            <div className="field col-12 md:col-2 mb-0">{!window.cn(userData?.RegNo) ? userData?.RegNo : ''}</div>
                        </div>
                    </div>
                </div>

                {/* Datatable */}
                {pageLoad ? (
                    <>
                        <DataTable value={verificationList} showGridlines stripedRows className="datatable-responsive  mt-3" emptyMessage="No Data Found">
                            {VerificationListColumns.map((col, i) => {
                                if (col.field === 'comment') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={commentTemplate} />;
                                } else if (col.field === 'created_at') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={verificationOrderDateTemplate} />;
                                } else if (col.field === 'verification_date') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={verificationDateTemplate} />;
                                } else if (col.field === 'reply') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={replyTemplate} />;
                                } else if (col.field === 'action') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={actionTemplate} />;
                                } else if (col.field === 'file_url') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={fileUrlTemplate} />;
                                } else if (col.field === 'reply_file') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={replyFileTemplate} />;
                                } else if (col.field === 'sr_no') {
                                    return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} />;
                                }
                            })}
                        </DataTable>
                    </>
                ) : (
                    <>
                        {/* Skeleton Data table */}
                        <DataTable value={Skeletonitems}>
                            {VerificationListColumns.map((col, i) => (
                                <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                            ))}
                        </DataTable>
                    </>
                )}
            </div>
        </>
    );
};
